<template>

        <div class="page-turning clearfix">

            <router-link 
                class="prev-page"
                v-if="infor.prevPage != '' " 
                :to="infor.prevPage || '/' "
                :title="infor.prevPageTitle"
            >
                <i></i><span class="btn">上一个:</span><span class="title">{{infor.prevPageTitle}}</span>
            </router-link>

            <router-link 
                class="next-page" 
                v-if="infor.nextPage!=''" 
                :to="infor.nextPage || '/' "
                :title="infor.nextPageTitle"
            >
                <span class="btn">下一个:</span><span class="title">{{infor.nextPageTitle}}</span><i></i>
            </router-link>

        </div>

</template>

<script>

// import jquery from 'jquery'
    
export default {
    name: 'BasePageTurning',
    props: {
        infor: Object
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

@media screen and (min-width: 801px) {
    .page-turning {
        max-width: 1200px;
        margin: 0 auto;
        padding-bottom: 30px;
        font-size: 14px;
        line-height: 1.5em;
        color: #333;
    }
    .prev-page {
        float: left;
    }
    .next-page {
        float: right;  
    }
    .prev-page:hover span,
    .next-page:hover span {
        border-bottom-color: #FF764E;
        color: #FF764E;
    }
    .prev-page .btn{
        margin-left: .5em;
        padding-right: 1em;
    }
    .next-page .title{
        margin-right: .5em;
        padding-left: 1em;
    }   
    .prev-page span,
    .next-page span {
        color: #333;
        border-bottom: 1px #333 solid;
    }

    .prev-page span,
    .next-page span{
        display: inline-block;
        vertical-align: middle;
        max-width: 16em;
        height: 1.5em;
        overflow: hidden;
        word-wrap: normal;
        word-break: keep-all;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    .prev-page i,
    .next-page i {
        position: relative;
        display: inline-block;
        width: 21px;
        height: 21px;
        vertical-align: middle;
    }

    .prev-page i:before {
        content: '';
        display: block;
        position: absolute;
        top: 4px;
        right: 4px;
        border-left: 8px transparent solid;
        border-right: 8px #333 solid;
        border-top: 6px transparent solid;
        border-bottom: 6px transparent solid;
        vertical-align: middle;
    }

    .next-page i:before {
        content: '';
        display: block;
        position: absolute;
        top: 3px;
        left: 3px;
        border-left: 8px #333 solid;
        border-right: 8px transparent solid;
        border-top: 6px transparent solid;
        border-bottom: 6px transparent solid;
        vertical-align: middle;
    }
}

@media screen and (max-width: 800px) {
    .page-turning {
        width: 9.04rem;
        margin: 0 auto;
        font-size: .32rem;
        line-height: 1.5em;
        margin-bottom: .533rem;
        color: #666;
    }
    .prev-page {
        float: left;
    }
    .next-page {
        float: right;
       
    }
    .prev-page span,
    .next-page span {
        border-bottom: 1px #333 solid;
    }
    .prev-page:active span,
    .next-page:active span {
        color: #FF764E;
        border-bottom-color: #FF764E;
    }   
    .prev-page .btn{
        margin-left: .5em;
        padding-right: 1em;
    }
    .next-page .title{
        margin-right: .2em;
        padding-left: .2em;
    }

    .prev-page span,
    .next-page span{
        display: inline-block;
        vertical-align: middle;
        max-width: 8em;
        height: 1.5em;
        overflow: hidden;
        word-wrap: normal;
        word-break: keep-all;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .prev-page i,
    .next-page i {
        position: relative;
        display: inline-block;
        width: 1em;
        height: 1.5em;
        vertical-align: middle;
    }

    .prev-page i:before {
        content: '';
        display: block;
        position: absolute;
        top: .25em;
        right: 0;
        border-left: .5em transparent solid;
        border-right: .5em #333 solid;
        border-top: .4em transparent solid;
        border-bottom: .4em transparent solid;
        vertical-align: middle;
    }

    .next-page i:before {
        content: '';
        display: block;
        position: absolute;
        top: .25em;
        left: 0;
        border-left: .5em #333 solid;
        border-right: .5em transparent solid;
        border-top: .4em transparent solid;
        border-bottom: .4em transparent solid;
        vertical-align: middle;
    }


}
</style>